<p-toast position="{{smallScreen ? 'bottom-right' : 'bottom-right'}}"></p-toast>

<p-confirmDialog #cd>
  <p-footer>
    <button type="button" pButton icon="pi pi-check" class="p-button-raised" label="Yes" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div style="height:100%;display:flex;flex-direction:column;min-height:0;">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <!-- Display breadcrumb only on bigger than md screens-->
      <p-breadcrumb [model]="items" class="p-d-none p-d-md-inline"></p-breadcrumb>

      <div style="padding-top:2px;">
        <button pButton type="button" 
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh" 
                (click)="loadEmployees()"></button>

        <!-- Display only on bigger than md screens-->
        <div class="p-d-none p-d-md-inline">
          <button *ngIf="canAddEmployee()" pButton type="button" 
                  class="p-button p-button-text" 
                  label="Add Employee" 
                  icon="pi-fw fas fa-user"
                  (click)="openEmployeeForm(null)"></button>

          <button *ngIf="canExportEmployee()" pButton type="button" 
                  class="p-button p-button-text" 
                  [class.disabled]="exporting"
                  label="Export" 
                  icon="{{exporting ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"
                  (click)="exportEmployee()"></button>

          <button *ngIf="canModifyEmployee()" 
                  (click)="openEmployeeForm(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button p-button-text" 
                  label="Edit Employee" 
                  icon="pi-fw fas fa-user-edit"></button>

          <button *ngIf="canModifyEmployee() && selectedRow" 
                  (click)="activateEmployee(selectedRow, !selectedRow.active);"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button p-button-text" 
                  [ngClass]="{'p-button-success': !selectedRow.active, 'p-button-danger': selectedRow.active}"
                  label="{{selectedRow.active ? 'Terminate' : 'Activate'}} Employee"
                  icon="pi-fw fas {{selectedRow.active?'fa-user-minus':'fa-user-plus'}}"></button>
        </div>

        <!-- Display only on smaller than md screens-->
        <span class="p-d-md-none">
          <button *ngIf="canAddEmployee()" pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw fas fa-user"
                  (click)="openEmployeeForm(null)"></button>

          <button *ngIf="canExportEmployee()" pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  [disabled]="exporting"
                  icon="{{exporting ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"
                  (click)="exportEmployee()"></button>

          <button *ngIf="canModifyEmployee()" 
                  (click)="openEmployeeForm(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw fas fa-user-edit"></button>

          <button *ngIf="canModifyEmployee() && selectedRow" 
                  (click)="activateEmployee(selectedRow, !selectedRow.active);"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button-rounded" 
                  [ngClass]="{'p-button-success': !selectedRow.active, 'p-button-danger': selectedRow.active}"
                  icon="pi-fw fas {{selectedRow.active?'fa-user-minus':'fa-user-plus'}}"></button>
        </span>
      </div>
    </div>

    <div class="p-toolbar-group-right">
      <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon text-success" pBadge 
         style="color: var(--green-600)" 
         severity="success"
         pTooltip="Total Number of Active Employees with Company Code <span style='color:yellow'>{{clientCode}}</span>: {{getTotalActiveEmployeeCount()}}"
         tooltipPosition="left"
         [escape]="false"
         value="{{getTotalActiveEmployeeCount()}}"></i>

      <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
         severity="info"
         pTooltip="Total Number of Employees: {{employees.length}}"
         value="{{employees.length}}"></i>
    </div>
  </p-toolbar>

  <div style="flex:1 1 auto;min-height:0;">
    <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
                 size="default"
                 color="#2f9cf2"
                 type="line-scale-pulse-out"
                 [name]="spinnerName"
                 [fullScreen]="false"><p style="color:white" >Loading employees... </p></ngx-spinner>
    <ag-grid-angular *ngIf="employees.length > 0"
                      style="width: 100%; height:100%;"
                      class="ag-theme-alpine"
                      [rowData]="employees"
                      [columnDefs]="gridHeaders"
                      [context]="context"
                      [gridOptions]="gridOptions"
                      [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
                      (rowDoubleClicked)='onRowDblClicked($event)'
                      (rowClicked)='onRowClicked($event)'
                      (gridReady)="onGridReady($event)">
    </ag-grid-angular>  
  </div>
</div>
